import {
  Input,
  EventEmitter,
  Output,
  OnChanges,
  Injector,
  Directive,
} from '@angular/core';

import { SelectListItem } from '@shared/models/selectlistitem';
import { FuncBaseDirective } from '@shared/base/func-base/func-base';

@Directive()
export abstract class SelectBaseDirective
  extends FuncBaseDirective
  implements OnChanges
{
  data: Array<SelectListItem> = [];
  originalData: Array<SelectListItem>;
  defaultSLI;
  prevMultiSLI;
  phname: string;
  allText: string;
  selectedItems = '%';
  panelClass: string;

  @Input() selectedValue = 0;
  @Input() filterable = false;
  @Input() multiple = false;
  @Input() all = true;
  @Input() disabled = false;
  @Output() selectionChanged = new EventEmitter();

  constructor(
    injector: Injector,
    phname: string,
    allText: string = 'all',
    widePanel: boolean = false
  ) {
    super(injector, phname);

    this.phname = phname;
    this.allText = allText;
    this.panelClass = widePanel ? 'mat-select-wide-panel' : 'mat-select-panel';

    this.defaultSLI = this.multiple ? [this.selectedValue] : this.selectedValue;
    this.prevMultiSLI = [this.defaultSLI];
  }

  ngOnChanges(): void {
    this.defaultSLI = this.multiple ? [this.selectedValue] : this.selectedValue;
  }

  private joinIds(elements: Array<any>) {
    return elements
      .map((elem) => {
        return elem;
      })
      .join(',');
  }

  onSelectMultiple(event: Array<any>) {
    if (event.length === 0) {
      this.selectedItems = '0';
    } else if (event[0] === 0 && event.length === 1) {
      this.selectedItems = '%';
    } else if (event[0] === 0 && event.length > 1) {
      if (this.prevMultiSLI[0] !== 0) {
        this.defaultSLI = [this.defaultSLI[0]];
        this.selectedItems = '%';
      } else {
        this.defaultSLI = this.defaultSLI.slice(1);
        this.selectedItems = this.joinIds(this.defaultSLI);
      }
    } else {
      this.selectedItems = this.joinIds(event);
    }
    this.prevMultiSLI = this.defaultSLI;

    this.selectionChanged.emit(this.selectedItems);
  }

  onSelectSingle(event: any) {
    if (event === 0) {
      event = '%';
    }
    this.selectionChanged.emit(event);
  }

  filterSelectValues(event: any) {
    if (this.originalData === null || this.originalData === undefined) {
      this.originalData = this.data;
    }
    this.data = this.originalData.filter((unit) =>
      unit.text.toLowerCase().includes(event.toLowerCase())
    );
  }
}
